/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Studio_Lock_HintInputs */

const en_landing_studio_lock_hint = /** @type {(inputs: Landing_Studio_Lock_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`After the edit, every unpainted pixel is copied back from your source.`)
};

const zh_landing_studio_lock_hint = /** @type {(inputs: Landing_Studio_Lock_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`编辑完成后，所有未涂抹的像素都从原图逐像素拷回。`)
};

/**
* | output |
* | --- |
* | "After the edit, every unpainted pixel is copied back from your source." |
*
* @param {Landing_Studio_Lock_HintInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_studio_lock_hint = /** @type {((inputs?: Landing_Studio_Lock_HintInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Studio_Lock_HintInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_studio_lock_hint(inputs)
	return zh_landing_studio_lock_hint(inputs)
});
export { landing_studio_lock_hint as "landing.studio.lock_hint" }